export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  getButtonState() {
    this.showButton = !!(this.formValues.firstName && this.formValues.firstName.length > 0)
  },
})
